import React, { Component } from 'react'
import Button from 'components/Button/Button'
import { graphql, compose, withApollo } from 'react-apollo'

import { REQUEST_ACTION_DATA, GET_ACTION_DATA } from 'graphql/all'

class ModalNotify extends Component {
    dismiss = () => {
        this.props.closeCallback()
    }

    render(){
        return(
            <div className="modal-delete">
                <div className="content-container">
                    <p>
                        { this.props.object }
                    </p>
                </div>
                <div className="button-row">
                    <Button label="Okay" level="high" callback={this.props.closeCallback} />
                </div>
            </div>
        )
    }
}

export default withApollo(ModalNotify)

  